import React, {Component} from "react"
import PropTypes from "prop-types"
import Button from '../../atoms/Button';
import {withRouter} from "react-router-dom"
import "./NewStag.css"

class NewStag extends Component {
  constructor(...args) {
    super(...args)
    this.state = {
      title: "",
    }
  }

  componentWillMount() {
    if (!this.props.authenticated) {
      this.props.history.push("/login?redirectTo=" + encodeURIComponent("/new"))
    }
  }

  handleChange = ev => {
    this.setState({
      [ev.target.name]: ev.target.value,
    })
  }

  render() {
    const {networkStatus} = this.props;
    const {title} = this.state

    const createStag = () => {
      this.props
        .createNewStag({
          homepage: {
            title,
          },
        })
        .then(({id, code}) => {
          this.props.history.push("/stag/" + id + "/admin/homepage")
        })
    }

    return (
      <div className="NewStag">
        <div>
          <label> Name </label>
          <input
            type="text"
            name="title"
            value={title}
            onChange={this.handleChange}
            placeholder="e.g. Bob Stag 2017..."
          />
        </div>
        <div>
          <Button onClick={createStag} disabled={!networkStatus}>Create</Button>
        </div>
      </div>
    )
  }
}

NewStag.propTypes = {
  createNewStag: PropTypes.func.isRequired,
  authenticated: PropTypes.bool.isRequired,
  networkStatus: PropTypes.bool.isRequired,
}

export default withRouter(NewStag)



// WEBPACK FOOTER //
// ./src/component/organisms/NewStag/component.js